import { INeoAction } from './../Actions.interface';
import { REQUEST_ACTIONS, STATUS } from '../../Constants/Actions.constants';
import { isActionValid } from '../../Helpers/Reducer.helper';

interface RecoveryReducerState {
  [x: string]: boolean;
}

export const INITIAL_STATE: RecoveryReducerState = {
  [REQUEST_ACTIONS.NEW_PASSWORD]: false,
  [REQUEST_ACTIONS.PASSWORD_RESET]: false,
};

const useActionNameValid = isActionValid([
  REQUEST_ACTIONS.NEW_PASSWORD,
  REQUEST_ACTIONS.PASSWORD_RESET,
]);

export default (state = INITIAL_STATE, action: INeoAction) => {
  const { name, status } = action;
  if (!name || !useActionNameValid(name)) {
    return state;
  }

  if (status === STATUS.SUCCESS) {
    return { ...state, [name]: true };
  }

  return state;
};
